module.exports = __webpack_public_path__ + "img/image8x1.3ff4c0ed.jpg";